export default __webpack_public_path__ + "static/media/no50x43.a54c8655.jpg";